import { useMemo, useState } from 'react';
import type { Arealplan } from '@origo/planregister';
import { type PlanFilters, type SortOption, emptyFilters, sortOptions } from './types';
import { applyFilters, sortPlans, countActiveFilters, hasActiveFilters } from './filterUtils';

export interface UsePlanFilterReturn {
    filters: PlanFilters;
    setFilters: (f: PlanFilters) => void;
    sortOption: SortOption;
    setSortOption: (o: SortOption) => void;
    filteredPlans: Arealplan[];
    activeFilterCount: number;
    hasActive: boolean;
    resetFilters: () => void;
}

export function usePlanFilter(plans: readonly Arealplan[]): UsePlanFilterReturn {
    const [filters, setFilters] = useState<PlanFilters>(emptyFilters);
    const [sortOption, setSortOption] = useState<SortOption>(sortOptions[0]);

    const filteredPlans = useMemo(
        () => sortPlans(applyFilters(plans, filters), sortOption),
        [plans, filters, sortOption]
    );

    return {
        filters,
        setFilters,
        sortOption,
        setSortOption,
        filteredPlans,
        activeFilterCount: countActiveFilters(filters),
        hasActive: hasActiveFilters(filters),
        resetFilters: () => setFilters(emptyFilters),
    };
}
